import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import qs from "qs";

export const fetchLogin = createAsyncThunk(
  "fetchLogin",
  async (data, thunkAPI) => {
    const url = process.env.REACT_APP_API_URL + "/login.php";
    const authorization = data.authorization;
    const options = {
      method: "post",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      data: qs.stringify(data),
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          sessionStorage.setItem(
            "id",
            result.data.login.map((x) => x.id)
          );
          sessionStorage.setItem(
            "name",
            result.data.login.map((x) => x.name)
          );
          sessionStorage.setItem(
            "email",
            result.data.login.map((x) => x.email)
          );
          sessionStorage.setItem(
            "group_id",
            result.data.login.map((x) => x.group_id)
          );
          return result.data;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);
